import graphqlRequest from "../assignmentRequest";
import {
  ENTITY_TYPE,
} from "Services/assignment/constants";
import GET_BATCH_ASSIGNMENTS from "./graphql";

export async function getBatchAssignments(payload) {
  const {entityIdList, entityType=ENTITY_TYPE.STUDENT, dateStart, dateEnd, districtId, schoolId, assignmentType, status, limit} = payload
  const response = await graphqlRequest(GET_BATCH_ASSIGNMENTS, {
    entityIdList,
    entityType,
    dateStart,
    dateEnd,
    districtId,
    schoolId,
    assignmentType,
    status,
    limit
  });
  return response.assignments
}